/**
 * API client for Gestión 4sat module
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

function headers() {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

function authHeaders() {
  const token = localStorage.getItem('token');
  return { 'Authorization': `Bearer ${token}` };
}

async function handleResponse(r) {
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error(body.detail || `Error ${r.status}`);
  }
  return r.json();
}

// Dashboard
export const getDashboard = () =>
  fetch(`${API_URL}/api/gestion4sat/dashboard`, { headers: headers() }).then(handleResponse);

// Config
export const getConfig = () =>
  fetch(`${API_URL}/api/gestion4sat/config`, { headers: headers() }).then(handleResponse);

export const updateConfig = (data) =>
  fetch(`${API_URL}/api/gestion4sat/config`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

// Empresas
export const getEmpresas = (params = {}) => {
  const sp = new URLSearchParams();
  if (params.q) sp.set('q', params.q);
  if (params.estado) sp.set('estado', params.estado);
  if (params.skip) sp.set('skip', params.skip);
  if (params.limit) sp.set('limit', params.limit);
  return fetch(`${API_URL}/api/gestion4sat/empresas?${sp}`, { headers: headers() }).then(handleResponse);
};

export const getEmpresa = (id) =>
  fetch(`${API_URL}/api/gestion4sat/empresas/${id}`, { headers: headers() }).then(handleResponse);

export const createEmpresa = (data) =>
  fetch(`${API_URL}/api/gestion4sat/empresas`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const updateEmpresa = (id, data) =>
  fetch(`${API_URL}/api/gestion4sat/empresas/${id}`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

// Dispositivos
export const getDispositivos = (params = {}) => {
  const sp = new URLSearchParams();
  if (params.q) sp.set('q', params.q);
  if (params.empresa_id) sp.set('empresa_id', params.empresa_id);
  if (params.estado) sp.set('estado', params.estado);
  if (params.sin_empresa) sp.set('sin_empresa', 'true');
  if (params.page) sp.set('page', params.page);
  if (params.limit) sp.set('limit', params.limit);
  if (params.gps_marca) sp.set('gps_marca', params.gps_marca);
  if (params.vehiculo_tipo) sp.set('vehiculo_tipo', params.vehiculo_tipo);
  if (params.vehiculo_marca) sp.set('vehiculo_marca', params.vehiculo_marca);
  if (params.activity_status) sp.set('activity_status', params.activity_status);
  if (params.fecha_desde) sp.set('fecha_desde', params.fecha_desde);
  if (params.fecha_hasta) sp.set('fecha_hasta', params.fecha_hasta);
  return fetch(`${API_URL}/api/gestion4sat/dispositivos?${sp}`, { headers: headers() }).then(handleResponse);
};

export const getDispositivosFiltros = () =>
  fetch(`${API_URL}/api/gestion4sat/dispositivos/filtros`, { headers: headers() }).then(handleResponse);

export const getDispositivo = (id) =>
  fetch(`${API_URL}/api/gestion4sat/dispositivos/${id}`, { headers: headers() }).then(handleResponse);

export const createDispositivo = (data) =>
  fetch(`${API_URL}/api/gestion4sat/dispositivos`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const updateDispositivo = (id, data) =>
  fetch(`${API_URL}/api/gestion4sat/dispositivos/${id}`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const buscarImeiPredictivo = (q) =>
  fetch(`${API_URL}/api/gestion4sat/dispositivos/buscar-imei?q=${encodeURIComponent(q)}`, { headers: headers() }).then(handleResponse);

// Sync Log
export const getSyncLog = (limit = 50) =>
  fetch(`${API_URL}/api/gestion4sat/sync-log?limit=${limit}`, { headers: headers() }).then(handleResponse);

// Linkify
export const linkifyStatus = () =>
  fetch(`${API_URL}/api/gestion4sat/linkify/status`, { headers: headers() }).then(handleResponse);

export const linkifyCrearCobros = (loteId) =>
  fetch(`${API_URL}/api/gestion4sat/linkify/crear-cobros/${loteId}`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const linkifyCobros = (loteId) =>
  fetch(`${API_URL}/api/gestion4sat/linkify/cobros${loteId ? `?lote_id=${loteId}` : ''}`, { headers: headers() }).then(handleResponse);

export const linkifyConsultarCobro = (cobroId) =>
  fetch(`${API_URL}/api/gestion4sat/linkify/cobros/${cobroId}/consultar`, { headers: headers() }).then(handleResponse);

export const linkifySyncEstados = () =>
  fetch(`${API_URL}/api/gestion4sat/linkify/sync-estados`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

// Alertas
export const getAlertas = (params = {}) => {
  const sp = new URLSearchParams();
  if (params.tipo) sp.set('tipo', params.tipo);
  if (params.estado) sp.set('estado', params.estado || 'pendiente');
  if (params.skip) sp.set('skip', params.skip);
  if (params.limit) sp.set('limit', params.limit);
  return fetch(`${API_URL}/api/gestion4sat/alertas?${sp}`, { headers: headers() }).then(handleResponse);
};

export const resolverAlerta = (id, data = {}) =>
  fetch(`${API_URL}/api/gestion4sat/alertas/${id}/resolver`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const ignorarAlerta = (id) =>
  fetch(`${API_URL}/api/gestion4sat/alertas/${id}/ignorar`, {
    method: 'PUT', headers: headers(),
  }).then(handleResponse);

// Importaciones
export const importarClientesFacto = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return fetch(`${API_URL}/api/gestion4sat/importar/clientes-facto`, {
    method: 'POST', headers: authHeaders(), body: fd,
  }).then(handleResponse);
};

export const importarDispositivos4sat = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return fetch(`${API_URL}/api/gestion4sat/importar/dispositivos-4sat`, {
    method: 'POST', headers: authHeaders(), body: fd,
  }).then(handleResponse);
};

export const importarTelcoSims = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return fetch(`${API_URL}/api/gestion4sat/importar/telco-sims`, {
    method: 'POST', headers: authHeaders(), body: fd,
  }).then(handleResponse);
};

export const getImportaciones = () =>
  fetch(`${API_URL}/api/gestion4sat/importaciones`, { headers: headers() }).then(handleResponse);

// Enriquecimiento SII
export const enriquecerRuts = () =>
  fetch(`${API_URL}/api/gestion4sat/enriquecer-ruts`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const estadoEnriquecimiento = () =>
  fetch(`${API_URL}/api/gestion4sat/enriquecer-ruts/estado`, { headers: headers() }).then(handleResponse);

// Stats
export const getStatsTipoServicio = () =>
  fetch(`${API_URL}/api/gestion4sat/stats/empresas-tipo-servicio`, { headers: headers() }).then(handleResponse);

// Servicios
export const getServicios = (params = {}) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) sp.set(k, v); });
  return fetch(`${API_URL}/api/gestion4sat/servicios?${sp}`, { headers: headers() }).then(handleResponse);
};

export const getServicio = (id) =>
  fetch(`${API_URL}/api/gestion4sat/servicios/${id}`, { headers: headers() }).then(handleResponse);

export const createServicio = (data) =>
  fetch(`${API_URL}/api/gestion4sat/servicios`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const updateServicio = (id, data) =>
  fetch(`${API_URL}/api/gestion4sat/servicios/${id}`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const getTiposServicio = () =>
  fetch(`${API_URL}/api/gestion4sat/tipos-servicio`, { headers: headers() }).then(handleResponse);

export const createTipoServicio = (data) =>
  fetch(`${API_URL}/api/gestion4sat/tipos-servicio`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

// Scrapers
export const scraperPatente = (patente) =>
  fetch(`${API_URL}/api/gestion4sat/scraper/patente/${encodeURIComponent(patente)}`, { headers: headers() }).then(handleResponse);

// Sync to 4sat.cl
export const syncTo4sat = (dispositivoId) =>
  fetch(`${API_URL}/api/gestion4sat/sync-to-4sat/${dispositivoId}`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const syncMasivoTo4sat = () =>
  fetch(`${API_URL}/api/gestion4sat/sync-to-4sat-masivo`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const scraperRut = (rut) =>
  fetch(`${API_URL}/api/gestion4sat/scraper/rut/${encodeURIComponent(rut)}`, { headers: headers() }).then(handleResponse);

// IMEI check
export const checkImei = (imei) =>
  fetch(`${API_URL}/api/gestion4sat/check-imei/${encodeURIComponent(imei)}`, { headers: headers() }).then(handleResponse);


// Facturación
export const previewMensualidades = (mes, anio) =>
  fetch(`${API_URL}/api/gestion4sat/facturacion/preview-mensualidades?mes=${mes}&anio=${anio}`, { headers: headers() }).then(handleResponse);

export const previewServicios = () =>
  fetch(`${API_URL}/api/gestion4sat/facturacion/preview-servicios`, { headers: headers() }).then(handleResponse);

export const getLotes = (params = {}) => {
  const sp = new URLSearchParams();
  if (params.estado) sp.set('estado', params.estado);
  return fetch(`${API_URL}/api/gestion4sat/facturacion/lotes?${sp}`, { headers: headers() }).then(handleResponse);
};

export const getLote = (id) =>
  fetch(`${API_URL}/api/gestion4sat/facturacion/lotes/${id}`, { headers: headers() }).then(handleResponse);

export const generarLote = (data) =>
  fetch(`${API_URL}/api/gestion4sat/facturacion/generar`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const facturarLote = (id) =>
  fetch(`${API_URL}/api/gestion4sat/facturacion/lotes/${id}/facturar`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const rollbackLote = (id) =>
  fetch(`${API_URL}/api/gestion4sat/facturacion/lotes/${id}/rollback`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const descargarExcelFacto = (id) => {
  const token = localStorage.getItem('token');
  return fetch(`${API_URL}/api/gestion4sat/facturacion/lotes/${id}/excel`, {
    headers: { 'Authorization': `Bearer ${token}` },
  }).then(r => {
    if (!r.ok) throw new Error('Error descargando Excel');
    return r.blob();
  }).then(blob => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Facto_${id}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  });
};


// Conciliación Bancaria
export const importarCartola = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return fetch(`${API_URL}/api/gestion4sat/conciliacion/importar-cartola`, {
    method: 'POST', headers: authHeaders(), body: fd,
  }).then(handleResponse);
};

export const getMovimientos = (params = {}) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) sp.set(k, v); });
  return fetch(`${API_URL}/api/gestion4sat/conciliacion/movimientos?${sp}`, { headers: headers() }).then(handleResponse);
};

export const getFacturasPendientes = () =>
  fetch(`${API_URL}/api/gestion4sat/conciliacion/facturas-pendientes`, { headers: headers() }).then(handleResponse);

export const autoMatch = () =>
  fetch(`${API_URL}/api/gestion4sat/conciliacion/auto-match`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const aprobarConciliacion = (data) =>
  fetch(`${API_URL}/api/gestion4sat/conciliacion/aprobar`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const aprobarMasivo = (items) =>
  fetch(`${API_URL}/api/gestion4sat/conciliacion/aprobar-masivo`, {
    method: 'POST', headers: headers(), body: JSON.stringify({ items }),
  }).then(handleResponse);

export const descartarMovimiento = (id) =>
  fetch(`${API_URL}/api/gestion4sat/conciliacion/descartar/${id}`, {
    method: 'POST', headers: headers(),
  }).then(handleResponse);

export const getResumenConciliacion = () =>
  fetch(`${API_URL}/api/gestion4sat/conciliacion/resumen`, { headers: headers() }).then(handleResponse);

export const getHistorialConciliaciones = () =>
  fetch(`${API_URL}/api/gestion4sat/conciliacion/historial`, { headers: headers() }).then(handleResponse);


// Conectividad
export const getConectividadDashboard = () =>
  fetch(`${API_URL}/api/gestion4sat/conectividad/dashboard`, { headers: headers() }).then(handleResponse);

export const getDispositivosOffline = (params = {}) => {
  const sp = new URLSearchParams();
  if (params.solo_activos !== undefined) sp.set('solo_activos', params.solo_activos);
  return fetch(`${API_URL}/api/gestion4sat/conectividad/dispositivos-offline?${sp}`, { headers: headers() }).then(handleResponse);
};

// Alertas mejoradas
export const resolverAlertasMasivo = (data) =>
  fetch(`${API_URL}/api/gestion4sat/alertas/resolver-masivo`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const getResumenAlertas = () =>
  fetch(`${API_URL}/api/gestion4sat/alertas/resumen`, { headers: headers() }).then(handleResponse);


// Órdenes de Trabajo
export const getOrdenesT = (params = {}) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) sp.set(k, v); });
  return fetch(`${API_URL}/api/gestion4sat/ordenes-trabajo?${sp}`, { headers: headers() }).then(handleResponse);
};

export const getOrdenT = (id) =>
  fetch(`${API_URL}/api/gestion4sat/ordenes-trabajo/${id}`, { headers: headers() }).then(handleResponse);

export const crearOrdenT = (data) =>
  fetch(`${API_URL}/api/gestion4sat/ordenes-trabajo`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const editarOrdenT = (id, data) =>
  fetch(`${API_URL}/api/gestion4sat/ordenes-trabajo/${id}`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const completarOrden = (id, data) =>
  fetch(`${API_URL}/api/gestion4sat/ordenes-trabajo/${id}/completar`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const getTecnicos = () =>
  fetch(`${API_URL}/api/gestion4sat/tecnicos`, { headers: headers() }).then(handleResponse);


// Fotos
export const subirFotoServicio = (servicioId, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return fetch(`${API_URL}/api/gestion4sat/servicios/${servicioId}/fotos`, {
    method: 'POST', headers: authHeaders(), body: fd,
  }).then(handleResponse);
};

export const getFotoUrl = (filename) => `${API_URL}/api/gestion4sat/fotos/${filename}`;

export const eliminarFoto = (servicioId, fotoId) =>
  fetch(`${API_URL}/api/gestion4sat/servicios/${servicioId}/fotos/${fotoId}`, {
    method: 'DELETE', headers: headers(),
  }).then(handleResponse);

// Scraper retry
export const encolarScrapePatente = (data) =>
  fetch(`${API_URL}/api/gestion4sat/scraper/encolar-patente`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);


// Geocode
export const geocodeAddress = (address) =>
  fetch(`${API_URL}/api/gestion4sat/geocode?address=${encodeURIComponent(address)}`, { headers: headers() }).then(handleResponse);

// Mapa de órdenes
export const getOrdenesMapa = (params = {}) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) sp.set(k, v); });
  return fetch(`${API_URL}/api/gestion4sat/ordenes-trabajo/mapa?${sp}`, { headers: headers() }).then(handleResponse);
};


// Tecnico ping (location tracking)
export const tecnicoPing = (coordenadas) =>
  fetch(`${API_URL}/api/gestion4sat/tecnico/ping`, {
    method: 'POST', headers: headers(), body: JSON.stringify({ coordenadas }),
  }).then(handleResponse);

// Admin mapa operativo
export const getMapaOperativo = (params = {}) => {
  const sp = new URLSearchParams();
  if (params.fecha) sp.set('fecha', params.fecha);
  return fetch(`${API_URL}/api/gestion4sat/admin/mapa-operativo?${sp}`, { headers: headers() }).then(handleResponse);
};


// ==================== FACTO (KOYWE) API ====================

export const factoStatus = () =>
  fetch(`${API_URL}/api/gestion4sat/facto/status`, { headers: headers() }).then(handleResponse);

export const factoDocumentTypes = () =>
  fetch(`${API_URL}/api/gestion4sat/facto/document-types`, { headers: headers() }).then(handleResponse);

export const factoEmitirDte = (data) =>
  fetch(`${API_URL}/api/gestion4sat/facto/emitir-dte`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const factoEmitirLote = (loteId, data = {}) =>
  fetch(`${API_URL}/api/gestion4sat/facto/emitir-lote/${loteId}`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const factoListarDtes = (params = {}) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') sp.set(k, String(v)); });
  return fetch(`${API_URL}/api/gestion4sat/facto/dtes?${sp}`, { headers: headers() }).then(handleResponse);
};

export const factoGetDte = (id) =>
  fetch(`${API_URL}/api/gestion4sat/facto/dtes/${id}`, { headers: headers() }).then(handleResponse);

export const factoDescargarPdf = async (dteId) => {
  const token = localStorage.getItem('token');
  const resp = await fetch(`${API_URL}/api/gestion4sat/facto/dtes/${dteId}/pdf`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  if (!resp.ok) throw new Error('Error descargando PDF');
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `DTE_${dteId}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
};

export const factoEmitirNotaCredito = (data) =>
  fetch(`${API_URL}/api/gestion4sat/facto/emitir-nota-credito`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);


export const factoSync = (data = {}) =>
  fetch(`${API_URL}/api/gestion4sat/facto/sync`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const factoRawDocument = (factoDocId) =>
  fetch(`${API_URL}/api/gestion4sat/facto/raw-document/${factoDocId}`, { headers: headers() }).then(handleResponse);

export const factoInfo = () =>
  fetch(`${API_URL}/api/gestion4sat/facto/info`, { headers: headers() }).then(handleResponse);

export const factoUpdateEstadoPago = (dteId, estadoPago) =>
  fetch(`${API_URL}/api/gestion4sat/facto/dtes/${dteId}/estado-pago`, {
    method: 'PATCH', headers: headers(), body: JSON.stringify({ estado_pago: estadoPago }),
  }).then(handleResponse);

export const factoBulkEstadoPago = (dteIds, estadoPago) =>
  fetch(`${API_URL}/api/gestion4sat/facto/dtes/bulk-estado-pago`, {
    method: 'PATCH', headers: headers(), body: JSON.stringify({ dte_ids: dteIds, estado_pago: estadoPago }),
  }).then(handleResponse);


export const uploadGiroLogo = async (file) => {
  const token = localStorage.getItem('token');
  const fd = new FormData();
  fd.append('file', file);
  const resp = await fetch(`${API_URL}/api/gestion4sat/config/upload-logo`, {
    headers: { 'Authorization': `Bearer ${token}` },
    method: 'POST',
    body: fd,
  });
  if (!resp.ok) {
    const d = await resp.json().catch(() => ({}));
    throw new Error(d.detail || 'Error subiendo logo');
  }
  return resp.json();
};


export const factoCapturarPatentes = (data) =>
  fetch(`${API_URL}/api/gestion4sat/facto/capturar-patentes`, {
    method: 'POST', headers: headers(), body: JSON.stringify(data),
  }).then(handleResponse);

export const factoCapturarPatentesStatus = (taskId) =>
  fetch(`${API_URL}/api/gestion4sat/facto/capturar-patentes/status/${taskId}`, {
    headers: headers(),
  }).then(handleResponse);

export const factoDashboard = () =>
  fetch(`${API_URL}/api/gestion4sat/facto/dashboard`, { headers: headers() }).then(handleResponse);

